import { useState, useEffect } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../../context/AuthContext";
import { account, storage } from "../../appwrite/config";
import AlertMessage from "../include/AlertMessage";
import ConfirmationPopup from "../include/ConfirmationPopup"; // ⬅️ Import new popup
import Pagination from "../Pagination";

var _ = require('lodash');

function Shops() {
  const navigate = useNavigate();
  //const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [data, setData] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const currentPage = Number(searchParams.get("page")) || 1;
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const limit = 24;

  const [alert, setAlert] = useState({ type: "", message: "" });
  const [showPopup, setShowPopup] = useState(false); // popup state
  const [deleteId, setDeleteId] = useState(null); // store user id for delete
  const [deleting, setDeleting] = useState(false);

  const { role, user } = useAuth();
  const token = sessionStorage.getItem('JWT_TOKEN');

  const fetchShops = async (page = currentPage) => {
    setLoading(true);

    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/shops`, {
        params: {
          category: 'all',
          latitude: 0,
          longitude: 0,
          radius: 0,
          userId: role === "admin" ? null : user?.$id, // Pass user ID for non-admins
          page,
          limit
        },
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token // Replace with your token
        }
      });

      const data = await response.data;
      if (Array.isArray(data.data) && data.data.length > 0) {
        const finaldata = data.data;
        (finaldata || []).map(shop => ({
          id: shop.$id,
          name: shop.name,
          category: shop.category,
          latitude: shop.latitude,
          longitude: shop.longitude,
          description: shop.description,
          createdAt: new Date(shop.$createdAt).toISOString().split('T')[0],
          isActive: shop.isActive ? '✅' : '❌'
        }))

        setData(finaldata);
        //setCurrentPage(data.pagination.page);
        setTotalPages(data.pagination.totalPages);
        setTotalRecords(data.pagination.total);
      }
    } catch (err) {
      const apierror = _.get(err, ['response', 'data', 'error', 'message'], "Something went wrong");
      setAlert({ type: "error", message: apierror });
      //logout();
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  };


  useEffect(() => {
    document.documentElement.className = "";
    fetchShops(currentPage);
  }, [currentPage]);

  const logout = async () => {
    await account.deleteSession("current");
    navigate("/");
  };

  const handleDelete = async () => {
    if (!deleteId) return;
    setDeleting(true);
    try {

      //Fecth sho detail to get file id for deletion from storage
      const spresponse = await axios.get(`${process.env.REACT_APP_API_URL}/fetchShopDetail/${deleteId}`, {
        headers: {
          'Authorization': 'Bearer ' + token // Replace with your token
        }
      });
      const shopresdata = spresponse.data.data;
      /*
            const imageIds = Array.isArray(shopresdata.imageID) ? shopresdata.imageID : [];
            for (let id of imageIds) {
              await storage.deleteFile(process.env.REACT_APP_BUCKET_ID, id);
            } */

      const response = await axios.delete(`${process.env.REACT_APP_API_URL}/deleteshop/${deleteId}`,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token // Replace with your token
          }
        }
      );
      
      if (response.status === 200 || response.status === 201 || response.status === 207) {
        const updatedData = data.filter(shop => shop.$id !== deleteId);

        setData(updatedData);

        setAlert({ type: "success", message: "Businesse deleted successfully!" });

        // ⭐ If page becomes empty go to previous page
        if (updatedData.length === 0 && currentPage > 1) {
          setSearchParams({
            page: currentPage - 1
          });
        }
      }
    } catch (err) {
      const apierror = _.get(err, ['response', 'data', 'error', 'message'], "Something went wrong");
      setAlert({ type: "error", message: apierror });
    } finally {
      setShowPopup(false); // close popup after action
      setDeleteId(null); // reset id
      setDeleting(false);
    }
  };

  //const visiblePages = getPagination(currentPage, totalPages);

  return (
    <section>
      <div className="is-title-bar">
        <div className="flex flex-col md:flex-row items-center justify-between space-y-6 md:space-y-0">
          <ul>
            <li><Link to="/dashboard" className='btn btn-primary'>Dashboard</Link></li>
            <li>Businesses</li>
          </ul>
          {role === "admin" && (
            <Link to="/shop/add" className='button blue'>Add Business</Link>
          )}
        </div>
      </div>
      <div className="section main-section">
        {alert.message && (
          <AlertMessage
            type={alert.type}
            message={alert.message}
            onClose={() => setAlert({ type: "", message: "" })}
            duration={3000}
          />
        )}
        {loading ? (
          <div className="flex justify-center items-center py-10">
            <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-blue-500 border-solid"></div>
          </div>

        ) : (
          Array.isArray(data) && data.length > 0 ? (
            <>
              <div className="grid gap-6 grid-cols-1 md:grid-cols-3 mb-6">
                {(data || []).map((item, index) => (
                  <div className="card" key={item.$id}>

                    <div className="card-content">
                      <div className="flex items-center justify-between">
                        <Link
                          className='btn btn-primary'
                          to={`/shop/edit/${item.$id}?page=${currentPage}`}
                        >

                          <div className="widget-label">
                            <h3>
                              {item.name}
                            </h3>
                            <p className="help">
                              {item.description}
                            </p>
                          </div>
                        </Link>
                        {["admin"].includes(role) && (
                          <span className="icon widget-icon text-red-500" onClick={() => {
                            if (deleting) return;
                            setDeleteId(item.$id);
                            setShowPopup(true);
                          }} style={{
                            cursor: deleting ? "not-allowed" : "pointer",
                            opacity: deleting ? 0.5 : 1
                          }}><i className="mdi mdi-trash-can mdi-48px"></i></span>
                        )}
                      </div>
                    </div>

                  </div>
                ))}
              </div>

              {totalPages > 1 && (
                <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  totalRecords={totalRecords}
                  onPageChange={(page) =>
                    setSearchParams({
                      page
                    })
                  }
                />
              )}
            </>
          ) : (
            <p style={{ color: 'red', fontWeight: 'bold', textAlign: 'center' }}>No Record Found.</p>
          )
        )}
      </div>
      {/* Confirmation Popup */}
      <ConfirmationPopup
        show={showPopup}
        onConfirm={handleDelete}
        onCancel={() => {
          if (!deleting) {
            setShowPopup(false);
          }
        }}
        title="Confirm Delete"
        message={
          deleting
            ? "Deleting business..."
            : "Are you sure you want to delete this Business?"
        }
        deleting={deleting}
      />
    </section >
  );

}

export default Shops;